import React from "react";
import { RiskStatusIcon } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { ASSESSMENT_TYPE_TO_TITLE } from "../../../constants";
import RenderChildrenWrapper from "../RenderChildrenWrapper";
import styles from "./assessmentCategory.module.scss";
const AssessmentCategory = ({ riskCategory, risk, variant = "stacked", risksCountWrapper, }) => {
    const disabled = risk.enabled === false;
    const title = (React.createElement("span", { className: styles["risk-title"] }, ASSESSMENT_TYPE_TO_TITLE[riskCategory]));
    const subline = (React.createElement("div", { className: styles["risk-subline"] },
        !disabled && risk.count > 0 && (React.createElement(RenderChildrenWrapper, { wrapper: risksCountWrapper &&
                ((children) => risksCountWrapper(risk, riskCategory, children)) },
            React.createElement("span", { className: styles["risk-count"] }, risk.count.toLocaleString()))),
        React.createElement("span", { className: styles["risk-subline-label"] }, risk.label)));
    return (React.createElement("div", { className: getClassName(disabled
            ? styles["risk-item-disabled"]
            : styles[`risk-item-${risk.status}`], styles[variant]) },
        React.createElement("span", { className: styles["risk-icon"] },
            React.createElement(RiskStatusIcon, { status: risk.status, disabled: disabled })),
        variant === "inline" ? (React.createElement(React.Fragment, null,
            title,
            subline)) : (React.createElement("div", { className: styles["risk-label"] },
            title,
            subline))));
};
export default AssessmentCategory;
//# sourceMappingURL=AssessmentCategory.js.map